import { ChainId } from '@pancakeswap/sdk'
import type { Provider } from '@ethersproject/providers'
import { SerializedWrappedToken } from '@pancakeswap/token-lists'
import BigNumber from 'bignumber.js'
import { PublicClient, Address } from 'viem'

export type OnChainProvider = ({ chainId }: { chainId?: ChainId }) => PublicClient

export type SerializedBigNumber = string

export interface Addresses {
  [chainId: number]: string
}

export enum PoolCategory {
  'NFT' = 'NFT',
}

// @deprecated
export interface PoolConfigBaseProps {
  sousId: number
  contractAddress: Address
  poolCategory: PoolCategory
  tokenPerSecond: string
  isFinished?: boolean
}

interface GenericToken {
  decimals: number
  symbol: string
  address: string
}

interface GenericNftToken {
  symbol: string
  address: string
}

export interface SerializedNftPoolConfig<T> extends PoolConfigBaseProps {
  earningToken: T & GenericToken
  stakingToken: T & GenericNftToken
  version: number
  nftMarketLink: string
}

export type SerializedNftPool = SerializedNftPoolConfig<SerializedWrappedToken>

export type SerializedNftPoolWithInfo = SerializedNftPool & SerializedNftPoolInfo

export interface DeserializedNftPoolConfig<T> extends PoolConfigBaseProps {
  earningToken: T & GenericToken
  stakingToken: T & GenericNftToken
  version: number
  nftMarketLink: string
}

interface SerializedNftPoolInfo extends CoreNftPoolProps {
  totalStaked?: string
  stakingLimit?: string
  stakingLimitEndTimestamp?: number
  userDataLoaded?: boolean
  userData?: {
    isApprovedForAll: boolean
    stakingNftBalance: string[]
    stakedNftBalance: string[]
    pendingReward: string
  }
}

interface PoolNftInfo extends CoreNftPoolProps {
  totalStaked?: BigNumber
  stakingLimit?: BigNumber
  stakingLimitEndTimestamp?: number
  userDataLoaded?: boolean
  userData?: {
    isApprovedForAll: boolean
    stakingNftBalance: string[]
    stakedNftBalance: string[]
    pendingReward: BigNumber
  }
}

export type DeserializedNftPool<T> = DeserializedNftPoolConfig<T> & PoolNftInfo

interface CoreNftPoolProps {
  startTimestamp?: number
  endTimestamp?: number
  apr?: number
  rawApr?: number
  stakingTokenPrice?: number
  earningTokenPrice?: number
}
